
const campaignTypeTranslations: Record<string, string> = {
  // Cashback types
  cashback_double: "Cashback em Dobro",
  extended_period: "Prazo Estendido",
  extra_cashback: "Cashback Extra",
  accumulated_spending: "Gasto Acumulado",
  
  // Referral types
  bonus_referral: "Bônus de Indicação",
  more_discount: "Maior Desconto",
  
  // Legacy/fallback
  percentage: "Percentual",
  fixed_value: "Valor Fixo",
};

export const getCampaignTypeDisplayName = (type: string): string => {
  return campaignTypeTranslations[type] || type;
};
